import { format } from 'date-fns';
import type { FC } from 'react';
import { EDR_COLORS, edrMutedStyle } from './edrTokens';

/** Inline `HH:mm:ss · dd MMM yyyy` for meta/timeline text. */
export const formatEdrDateTime = (value?: string | null): string => {
  const raw = (value ?? '').trim();
  if (!raw) return '—';
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return raw;
  return `${format(date, 'HH:mm:ss')} · ${format(date, 'dd MMM yyyy')}`;
};

/** Two-line timestamp for table/detail cells. */
export const EdrDateTime: FC<{ value?: string | null }> = ({ value }) => {
  const raw = (value ?? '').trim();
  if (!raw || raw === '—') return <span style={edrMutedStyle}>—</span>;

  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) {
    return <span style={{ fontSize: 12, color: EDR_COLORS.textSecondary }}>{raw}</span>;
  }

  return (
    <span style={{ display: 'inline-block', lineHeight: 1.25, textAlign: 'right' }}>
      <span style={{ display: 'block', fontSize: 12, fontWeight: 700, color: EDR_COLORS.textPrimary }}>
        {format(date, 'HH:mm:ss')}
      </span>
      <span style={{ display: 'block', fontSize: 11, color: EDR_COLORS.textMuted }}>
        {format(date, 'dd MMM yyyy')}
      </span>
    </span>
  );
};
